import React, {useState} from "react";
import {Row} from "antd";
import {useTranslation} from "react-i18next";
import {PlusOutlined} from "@ant-design/icons";
import {AssignPermissionPoliciesButton} from "./AllowedPermissionPoliciesTabStyles";
import AllowedPermissionPoliciesAssignModal from "./allowedPermissionPoliciesAssignModal/AllowedPermissionPoliciesAssignModal";
import {PermissionPolicyList} from "../../permissionPolicyList/PermissionPolicyList";
import {UnassignAllowedPermissionPolicyButton} from "./unassignAllowedPermissionPolicyButton/UnassignAllowedPermissionPolicyButton";
export const AllowedPermissionPoliciesTab = ({
    userId,
    permissionPolicies = [],
    loading = false,
    csrSearchText = "",
    recall = () => {}
}) => {
    const {t} = useTranslation(["userAuthorization"]);
    const [
        assignPermissionPoliciesModalVisibility,
        setAssignPermissionPoliciesModalVisibility
    ] = useState(false);

    return (
        <div>
            <AllowedPermissionPoliciesAssignModal
                userId={userId}
                visibility={assignPermissionPoliciesModalVisibility}
                allowedPermissionPolicies={permissionPolicies}
                onSuccess={() => {
                    setAssignPermissionPoliciesModalVisibility(false);
                    recall();
                }}
                onCancel={() => setAssignPermissionPoliciesModalVisibility(false)}
            />
            <Row type="flex" justify="end">
                <AssignPermissionPoliciesButton
                    size="small"
                    icon={<PlusOutlined />}
                    data-testid="assignPermissionPolicyButton"
                    onClick={() => setAssignPermissionPoliciesModalVisibility(true)}
                >
                    {t("components.assignPermissionPoliciesButton.label", {
                        ns: "userAuthorization"
                    })}
                </AssignPermissionPoliciesButton>
            </Row>
            <PermissionPolicyList
                permissionPolicies={permissionPolicies}
                loading={loading}
                csrSearchText={csrSearchText}
                showActionColumn={true}
                actionButton={(attr, item) => (
                    <span data-testid="unassignAllowedPermissionPolicy">
                        <UnassignAllowedPermissionPolicyButton
                            userId={userId}
                            permissionPolicyKey={item?.key}
                            recall={recall}
                        />
                    </span>
                )}
            />
        </div>
    );
};
